"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ModelFilter = void 0;

var _modelFilter = _interopRequireDefault(require("./components/model-filter"));

exports.ModelFilter = _modelFilter["default"];